const es = {
  /* WELLCOME */
  start: 'Comenzar',
  signup: 'Crear mi cuenta',
  makeurkids: 'Mejora la atención y la concentración con el sorobán',
  funlearning: 'Aprendizaje divertido',
  willlearntoopperate: 'Aprende a operar con los números de manera visual y divertida',
  dontworry: 'No os preocupéis',
  secure100pc: 'Esta aplicación es 100 % segura, sin molestos banners ni anuncios',
  sharemess: 'La app para obtener el poder del ábaco japonés. Activa tu capacidad mental, diviértete con las matemáticas, gana en concentración, atención y razonamiento.',
  thankssharing: '¡Gracias por compartir!',

  /* REGISTER STEPS */
  language: 'Idioma',
  agelevel: 'Rango de edad',
  chooseagerange: 'Escoge tu rango de edad para adaptar el curso y los retos',
  chooseanavatar: 'Escoge tu avatar',

  wellcome: 'Bienvenidos/as',
  alwaysyouwant: 'Siempre que quieras recibirás información del progreso de tu hijo/ hija',
  yourname: '¿Cómo te llamas?',
  country: 'País',
  continue: 'Continuar',
  alwaysconnected: 'Conéctate desde cualquier móvil o desde la web con tu cuenta',
  changeyourname: '¿Cómo te quieres llamar?',

  loginacc: 'Acceder con mi cuenta',
  readAndAccept: 'He leído y acepto los',
  TOS: 'Términos y condiciones de uso',
  TCS: 'Términos de recepción de notificaciones',

  morestars: 'MiSoroban no es solo para un único hijo/ hija, puedes añadir más protagonistas',
  howmanystars: '¿Cuántos protagonistas son ?',

  tellusname: 'Dinos cómo podemos llamar a las estrellas de esta aventura',
  gamer: 'Jugador',
  nickname: 'Apodo del jugador/a',
  age: 'Edad del jugador/a',
  other: 'Otro',

  emailalreadyexists: 'El usaurio o email ya existe.',

  loading: 'Cargando',
  almostthere: 'Ya casi estamos',
  preparing: 'Estamos preparando los últimos detalles para tu zona de aprendizaje',

  /* SECCIONES */
  learn: 'Aprende',
  practice: 'Practica',
  challengeyourself: 'Ponte a prueba',
  course: 'Curso',
  master: 'Perfecciona',
  teach: 'Enseña',

  /* LEARN */
  levels: 'Niveles',
  upgradelevel: 'Asciende de nivel',
  paper: 'Nivel Papel',
  wood: 'Nivel Madera',
  iron: 'Nivel Hierro',
  wool: 'Nivel Lana',
  bronze: 'Nivel Bronce',
  clay: 'Nivel Arcilla',
  steel: 'Nivel Acero',
  ivory: 'Nivel Marfil',
  glass: 'Nivel Cristal',
  silver: 'Nivel Plata',
  pearl: 'Nivel Perla',
  coral: 'Nivel Coral',
  ruby: 'Nivel Rubí',
  sapphire: 'Nivel Zafiro',
  gold: 'Nivel Oro',
  emerald: 'Nivel Esmeralda',
  diamond: 'Nivel Diamante',

  /*UNITS*/
  numbers1to10: 'Números del 1 al 10',
  knowtheabacus: 'Conoce el soroban',
  numbersinabacus: 'Los números',
  quantitygame: 'Juego de cantidades',
  realtionsgame: 'Juego de relaciones',
  idunits: 'Identifica números',
  repunits: 'Representa números',
  visualizeabacus: 'Visualiza el soroban',

  easysumsandsubs: 'Suma y resta',
  sumsubsboard: 'Suma y resta en el tablero',
  practiceboard: 'Practica en el tablero',
  sumsubsabacus: 'Suma y resta en el ábaco',
  practiceabacus: 'Practica en el ábaco',
  visualizebeads: 'Juego de las cuentas',

  strengthenlearnt: 'Practica',
  matchchall: 'Reto de las parejas',
  baloonschall: 'Reto de globos',
  mentalsumchall: 'Reto de la suma mental',
  mentalsubchall: 'Reto de la resta mental',
  mentalsumsubchall: 'Reto de la suma y resta mental',

  sumswith5: 'Suma con el 5',

  subswith5: 'Resta con el 5',

  numberstill99: 'Las decenas',

  sumswith10: 'Suma con el 10',

  subswith10: 'Resta con el 10',

  numberstill999: 'Las centenas',

  sumsandsubswith2: 'Suma y resta 2 cifras',

  sumsandsubswith3: 'Suma y resta 3 cifras',

  multi1: 'Multiplica x 1 cifra',

  divi1: 'Divide / 1 cifra',

  sumsandsubswith4: 'Suma y resta 4 cifras',

  multi2: 'Multiplica x 2 cifra',

  divi2: 'Divide / 2 cifra',

  learnnumbers: 'Aprende los números',

  // Edad 2
  numbers1_2_3_figs: 'Números en el ábaco',
  idnumbers: 'Identifica números',
  repnumbers: 'Representa números',


  /* 1 */
  sumboard: 'Suma en el tablero',
  sumabacus: 'Suma en el ábaco',
  subsboard: 'Resta en el tablero',
  subsabacus: 'Resta en el ábaco',
  sumserieschall: 'Reto de las sumas',
  subsserieschall: 'Reto de las restas',

  tens: 'Decenas',
  idtens: 'Identifica decenas',
  reptens: 'Representa decenas',
  practiceboardI: 'Práctica simple en el tablero',
  practiceboardII: 'Práctica avanzada en el tablero',
  practiceabacusI: 'Práctica simple en el ábaco',
  practiceabacusII: 'Práctica avanzada en el ábaco',

  sumserieschallI: 'Reto de la sumas básicas',
  sumserieschallII: 'Reto de la sumas intermedias',
  sumserieschallIII: 'Reto de la sumas avanzadas',
  subsserieschallI: 'Reto de la restas básicas',
  subsserieschallII: 'Reto de la restas intermedias',
  subsserieschallIII: 'Reto de la restas avanzadas',

  hundreds: 'Centenas',
  idhundreds: 'Identifica centenas',
  rephundreds: 'Representa centenas',
  pathchall: 'Reto del camino',
  practicesums: 'Practica las sumas',
  practicesubs: 'Practica las restas',
  practicebasesums: 'Practica las sumas I',
  practicebasesubs: 'Practica las restas I',
  practiceadvancedsums: 'Practica las sumas II',
  practiceadvancedsubs: 'Practica las restas II',

  multi1x2: 'Multiplicaciones 1x2 cifras',
  practiceabacus1x2: 'Practica 1x2 en el ábaco',
  multi1x3: 'Multiplicaciones 1x3 cifras',
  practiceabacus1x3: 'Practica 1x3 en el ábaco',
  challmultI: 'Reto inicial de multiplicaciones',
  challmultII: 'Reto avanzado de multiplicaciones',

  multi2x2: 'Multiplicaciones 2x2 cifras',
  practiceabacus2x2: 'Practica 2x2 en el ábaco',
  multi2x3: 'Multiplicaciones 2x3 cifras',
  practiceabacus2x3: 'Practica 2x3 en el ábaco',


  baloonschallI: 'Reto de globos inicial',
  baloonschallII: 'Reto de globos intermedio',

  'divide2:1': 'Divisiones 2÷1 cifras',
  'practiceabacus2:1': 'Practica 2÷1 en el ábaco',
  'divide3:1': 'Divisiones 3÷1 cifras',
  'practiceabacus3:1': 'Practica 3÷1 en el ábaco',
  challdivI: 'Reto inicial de las divisiones',
  challdivII: 'Reto avanzado de las divisiones',

  idthous: 'Identifica millares',
  repthous: 'Representa millares',

  'divide:2': 'Divisiones entre 2 cifras',

  /* LOGIN */
  profile: 'Perfil',
  editProfile: 'Editar Perfil',
  forgotPsw: '¿Has olvidado tu contraseña?',
  login: 'Login',
  noId: 'Datos de acceso incorrectos.',
  loginWith: 'Iniciar sesión con',
  createProfile: 'Crea un usuario',

  email: 'Email',
  password: 'Contraseña',

  data: 'Datos',
  protagonists: 'Protagonistas',
  logout: 'Salir',
  deleteAccount: 'Borrar cuenta',
  sureDeleteAccount: '¿Está seguro que quiere borrar esta cuenta?',
  yes: 'Sí',
  no: 'No',

  loginerror: 'Los datos de acceso son incorrectos',

  /* REMEMBER */
  wesendpass: 'Te hemos enviado un mensaje a tu email con tu nueva contraseña',
  recovepass: 'Recupera tu contraseña',

  /* GAMEZ*/
  next: 'Siguiente',
  grade: 'Validar',
  ready: 'Listo',

  number: 'número',

  bravoin: '¡¡Bravo!!, has superado el reto en',
  bravosur: '¡¡Bravo!!, has superado el reto',
  surpassedin: 'has superado el reto en',
  great: 'Genial, sigue así!',
  great01: 'Excelente, continua así!',
  great02: 'Brillante, sigue adelante!',
  great03: 'Fantástico, no te detengas!',
  great04: 'Impresionante, mantén el ritmo!',
  great05: 'Estupendo, prosigue igual!',
  great06: 'Increíble, sigue en esa línea!',
  great07: 'Magnífico, sigue con todo!',
  great08: 'Perfecto, sigue así!',
  great09: 'Sensacional, adelante siempre!',
  great10: 'Fenomenal, sigue por más!',
  nodiscorage: `No te desanimes, a por la próxima!`,
  nodiscorage01: 'Ánimo, sigue intentando!',
  nodiscorage02: 'No te rindas, sigue!',
  nodiscorage03: 'Vamos, tú puedes lograrlo!',
  nodiscorage04: 'Sigue adelante, no pares!',
  nodiscorage05: 'Tranquilo, la próxima es tuya!',
  nodiscorage06: 'Tú puedes, inténtalo de nuevo!',
  nodiscorage07: 'No te detengas, sigue luchando!',
  nodiscorage08: 'A por ello, no te desanimes!',
  nodiscorage09: 'Fuerza, la próxima será mejor!',
  nodiscorage10: 'Dale con todo, confía en ti!',

  rightanswer: 'Respuesta correcta!',
  wrong: 'Te has equivocado',
  yourwrong: 'Te has equivocado, el número es el',
  wronganswer: 'Oh!, Respuesta incorrecta, el número es el',
  theansweris: 'Respuesta incorrecta, la solución es',
  is: 'es',

  rightserie: 'Serie correcta!',

  havedone: 'Has realizado',
  exercises: 'ejercicios',
  tests: 'pruebas',
  havegotten: 'Has tenido',
  havemade: 'Has cometido',
  hits: 'aciertos',
  errors: 'errores',
  in: 'En un total de',
  seconds: 'segundos',
  repeat: 'Repetir',
  accept: 'Aceptar',
  timeout: '¡Te has quedado sin tiempo!',
  overcomechall: '¡Has superado el reto!',
  noovercomechall: 'No has superado el reto',

  bravo: '¡¡Bravo!!',
  oops: 'Prueba de nuevo!',
  haveovercomelevel: 'Has superado el nivel',
  nothaveovercomelevel: 'No has superado el nivel',
  watchexers: 'Ver ejercicios',
  watchlevels: 'Ver niveles',

  rightpath: 'Muy bien! Has encontrado el camino!',
  wrongpath: 'Oh!, Camino incorrecto. Te lo marcamos...',

  changeorientation: 'Cambia la orientación',

  nowcloseyesandvisualize: '...ahora cierra los ojos y visualiza el ábaco',

  module: 'resto',

  rightpos: 'Posición correcta :) !',
  wrongpos: 'Oh!, Posición incorrecta :/',

  verywellkeepon: 'Muy bien! sigue así!',
  yujumakeit: '¡¡Yuju!! Lo lograste :D !',
  almostyou: 'Ya casi lo tienes!',

  /* GAMEZ IMPLEMENTATION */

  test: 'Test',
  challenge: 'Reto',
  mental: 'Cálculo mental',
  mentalsums: 'Cálculo mental - Sumas',
  mentalsubs: 'Cálculo mental - Restas',

  // Gamez
  // baloonschall: '', // Ya está definido
  memoset: 'Memo',
  mentalabacusfixation: 'Visualiza',
  mentalsumsubstraction: 'Suma y resta mental',
  multiplydivide: 'Multiplica y divide',
  // pathchall: '', // Ya está definido
  // quantitygame: '', // Ya está definido
  representinabacus: 'Usa el ábaco',
  sumsubstractionnumber: 'Suma y resta',
  sumsubstractionseries: 'Series',
  theory: 'Teoría',
  whatnumberis: 'Identifica números',
  cartoonlayout: 'Usa el tablero',
  coupleschall: 'Reto de parejas',
  guidedsequence: 'Identifica la secuencia',
  // Challenges
  equationchallenge: 'Reto de la ecuación',
  numericpath: 'Reto del camino',
  memomeshchallenge: 'Memoria',
  // completeoperations: '', // Ya está definido
  numberriddle: 'Reto del acertijo',

  /* NEXT VERSION */
  levelnoaviable: 'Nivel no disponible',
  levelnoaviabletxt: 'Este nivel estará disponible en la siguiente versión de la app',
  rate: 'Valora MiSoroban',

  /* SUBSCRIPTION */
  try3days: 'Prueba MiSoroban 3 días gratis.',
  onallplans: 'En todos los planes.',
  cancelwhenyouwant: 'Cancela cuando quieras.',
  subscribe: 'Subscríbete',
  subscribetoactivate: 'Suscríbete para activar',
  subscribetoactivateteach: 'Suscríbete como profesor',
  subscribetoactivateGoogleplay: 'Activa en Google Play',
  subscribetoactivateAppleStore: 'Activa en Apple Store',
  morethan25: 'Más de 25 lecciones y decenas de ejercicios para disfrutar con el soroban.',
  startnow: 'Empezar ahora',
  autorenewable: 'Subscripción auto-renovable.',
  month: 'mes',
  months: 'meses',
  year: 'año',
  montly: 'Acceso Mensual',
  quaterly: 'Acceso Trimestral',
  yearly: 'Acceso Anual',
  managesubscription: 'Gestionar subscripción',
  howfreetrialworks: '¿Cómo funciona la prueba gratuita?',
  paymentDetailApple: 'Al confirmar la subscripción, tendrás 3 días gratis de prueba donde no se harán cargos (*). Tras el periodo de prueba gratuito, el pago se cargará a tu cuenta. Las suscripciones se renovarán automáticamente a menos que la renovación automática se desactive al menos 24 horas antes del final del período actual. Tu cuenta será cargada de acuerdo a tu plan para la renovación dentro de las 24 horas previas al final del período actual. Puedes gestionar o desactivar la renovación automática en la configuración de tu cuenta de Apple ID en cualquier momento después de la compra.',
  onlyfirstsubscription: '(* válido sólo en tu primera subscripción)',
  termsandconditions: 'Términos & Condiciones',
  privacypolicy: 'Política de privacidad',
  ifalreadysubscribed: 'Si ya estás suscrito',
  restorePurchases: 'Restaurar',
  forparentsonly: `Esta área es solo para adultos`,
  dragshapes: `Arrastra las formas en el siguiente orden`,
  airplane: 'avión',
  automobile: 'automóvil',
  cat: 'gato',
  notcorrect: 'No es correcto',
  tryagain: 'Nuevo intento',
  download_app: 'Activa la app',

  /* PRACTICES */
  practicesumsp: 'Sumas',
  practicesubstractions: 'Restas',
  practicemultiplications: 'Multiplicaciones',
  practicedivisions: 'Divisiones',
  easysums: '1 y 2 cifras',
  intermediatesums: '2 y 3 cifras',
  hardsums: '3 y 4 cifras',
  easysubs: '1 y 2 cifras',
  intermediatesubs: '2 y 3 cifras',
  hardsubs: '3 y 4 cifras',
  easymults: '1 x 2 cifras',
  easymults2: '1 x 3 cifras',
  intermediatemults: '2 x 2 cifras',
  hardmults: '2 x 3 cifras',
  easydivs: '2 / 1 cifras',
  easydivs2: '3 / 1 cifras',
  intermediatedivs: '3 / 2 cifras',
  harddivs: '4 / 2 cifras',

  /* CHALLENGES */
  getmorepoints: 'Consigue más puntos',
  completeoperations: 'Completa las operaciones',
  solveequation: 'Resuelve la ecuación',
  findpath: 'Encuentra el camino',
  challengevisualmem: 'Reta tu memoria visual',
  findvalue: 'Descubre el valor',
  youearned: 'Has conseguido',

  /* COURSE */
  numbers_sums_subtractions: 'Números, sumas y restas',
  multiply_divide: 'Multiplica y divide',
  numbers: 'Números',
  simplesumsubs: 'Sumas y restas sencillas',
  sumsubwith5: 'Sumas y restas con el 5',
  sumsubwith10: 'Sumas y restas con el 10',
  sumsub2c: 'Suma y resta con 2 cifras',
  sumsub3c: 'Suma y resta con 3 cifras',
  mult1c: 'Multiplicaciones 1 cifra',
  div1c: 'Divisiones 1 cifra',
  mult2c: 'Multiplicaciones 2 cifras',
  div2c: 'Divisiones 2 cifras',
  welcome: 'Bienvenid@',
  welcomefromtutor: 'Bienvenida del tutor',
  presentationModule1: ' Presentación Módulo 1',
  presentationModule2: ' Presentación Módulo 2',
  module1title: 'Módulo 1- Representar, identificar, sumar y restar',
  module1intro: `En este módulo aprenderás a mover las cuentas para representar números en el ábaco japonés, y también a sumar y restar con números de 1, 2 y 3 cifras. Los ejercicios además de ayudarte a redescubrir los números y las operaciones con esta herramienta, te ayudarán a trabajar el cálculo mental, la atención y la concentración.
Accede a la plataforma del curso con tu usuario y contraseña. Entra en la primera unidad del módulo y después de visualizar los videos para formarte, practica con los ejercicios. Cuando creas que estás preparado, accede a la siguiente unidad y avanza a tu ritmo.
Al final encontrarás una unidad especial donde puedes ponerte a prueba y ver todo lo que has aprendido.`,
  module2title: 'Módulo 2- Multiplicar y dividir',
  module2intro: `En este módulo aprenderás a realizar diferentes multiplicaciones y divisiones en el ábaco japonés. Aprenderás a estimar resultados y a visualizar el proceso de la operación.
Accede a las unidades de este segundo módulo. Comienza con la primera y avanza a la siguiente cuando consideres que estás preparado. En cada unidad, después de visualizar los vídeos practica con los ejercicios.
La última unidad te servirá para ponerte a prueba y ver todo lo que has aprendido.`,

  /* RESOURCES */
  resources: 'Recursos para enseñar',
  howtouseresources: 'Cómo usar estos recursos',
  intro: 'Introducción',
  discover: 'Descubre',

  /* RANKING */
  yourpoints: 'Tus puntos',
  yourposition: 'Tu posición',
  top10ranking: 'Top ranking', //'Top 10 ranking',

  /* REVIEW */
  issatisfied: '¿Te está gustando MiSoroban?',
  wannarate: '!Excelente¡ Nos gustaría que nos pudieras puntuar.',
  howcanimprove: 'Sentimos oir esto. ¿Cómo podemos mejorar?',
  tellushowimprove: 'Escribe tu respuesta...',
  thanksforyourfeedback: '!Gracias por tu feddback!',
  ok: 'OK',
  ratenow: 'Puntuar',
  later: 'Más tarde',
  send: 'Enviar',


  /* DAILY GOAL */
  dailygoal: 'Meta diaria',
  hi: 'Hola',
  selectdailygoal: 'Selecciona una meta diaria para mantener tu cerebro activo.',
  done: 'Hecho!',
  dailygoalreached: '¡¡Meta diaria alcanzada!!',
  youreachurdailygoal: 'has logrado tu meta diaria de',
  youwon: 'Has ganado',
  match: 'Logrado',
  youhavebeenworking: 'Has trabajado',
  outof: 'de',
  keepon: '¡Sigue así!',
  halfway: '¡Ya estás a mitad de camino!',
  almosthere: '¡Ya casi has llegado!',

  /* SHARE */
  sharemis: 'Comparte MiSoroban',

  /* tutor */
  strengthen: 'Reforzar',
  doyoulikekoyu: '¿Te está gustando Koyu?',
  wannatrytutor: '¿Quieres probar el nuevo "Tutor de MiSoroban"?',

  /* teach */
  joinOrCreateClassTitle: 'Únete o crea una clase',
  chooseOptionBelow: 'Elige una opción para continuar',
  createClass: 'Crea una clase',
  create: 'Crear',
  joinClass: 'Acceder a una clase',
  myClasses: 'Mis clases',
  noClassesFound: 'No se han encontrado clases',
  className: 'Nombre',
  enterClassName: 'Nombre de la clase',
  classLevel: 'Nivel',
  enterClassLevel: 'Selecciona el nivel',
  enterClassCode: 'Código de la clase',
  enterYourName: 'Tu nombre',
  join: 'Acceder',
  inviteStudents: 'Invita a tus alumnos a',
  onthe: 'en la',
  maxNStudents: 'Número máximo de alumnos',
  maxNStudentsReached: 'Número máximo de alumnos alcanzado. Contacta con el profesor.',
  orInApp: 'o en la web',
  classcode: 'Código de clase',
  class: 'Clase',
  students: 'alumnos',
  joined: 'se unieron',
  advance: 'Avance',
  beginning: 'Inicio',
  incorrectClassCode: 'El código de clase es incorrecto',
  studentNameAlreadyExist: 'El nombre del alumno ya existe. Elige otro.',
  correctErrors: 'Corrige los errores',
  createclassesandtournaments: 'Crea clases y mini torneos. Acceso completo. Comparte el poder del sorobán con tus alumnos o grupo.',
  teachsubtitle: 'Crea clases y mini torneos. Comparte el poder del sorobán con tus alumnos o grupo.',
  montlyteach: 'Profesor 1 clase',
  montlyteach5: 'Profesor 5 clases',
  firstfree: 'La primera clase gratis (con acceso limitado). Suscríbete como profesor para acceso completo o para crear más clases.',
  alreadyfirstfree: 'Ya tienes una clase creada. Suscríbete como profesor para crear más clases.',
  classLimitReached: 'Has alcanzado el límite de tus clases. Elimina clases o Suscríbete para crear más clases.',
  needmorecontact: 'Si necesitas otras opciones, contacta con',
  deleteClass: 'Eliminar clase',
  deleteOnlyIfNoStudents: '⚠︎ Solo se puede eliminar una clase si tiene "0" alumnos.',
  deleteclasswilleliminatestudentsaccess: 'Al borrar esta clase se eliminarás el acceso de los alumnos a la app.',
  delete: 'Borrar',
  cancel: 'Cancelar',
  areyouteacher: '¿Eres profesor, formador?',
  byfirsttime: 'Por primera vez',
  alreadyjoined: 'Ya estoy inscrito',
  classes: 'Clases',
  competition: 'Mini torneo',
  competitions: 'Mini torneos',
  createCompetition: 'Crear un mini torneo',
  enterCompetitionName: 'Nombre del mini torneo',
  selectClass: 'Selecciona la clase',
  selectExercises: 'Añade ejercicios',
  maxExercises: 'Máximo {{N}} ejercicios',
  classesMustExist: 'Debes crear al menos una clase',
  addExercise: 'Añade ejercicios',
  level: 'Nivel',
  max_exers_reached: '¡Número máximo de ejercicios alcanzado!',
  myCompetitions: 'Mis mini torneos',
  inviteStudentsCompetition: 'Invita a tus alumnos a acceder a 🏆 en la',
  thenAccessCompetition: 'luego a ',
  deleteCompetition: 'Eliminar mini torneo',
  deletecompetitionwilleliminatestudentsaccess: 'Al borrar este mini torneo se eliminarás el acceso de los alumnos.',
  waitingStudents: 'Esperando participantes',
  participants: 'participantes',
  challenges: 'retos',
  readytoopen: 'Tu mini torneo está listo para comenzar. Cuando quieras, pulsa "Abrir" para que los participantes puedan apuntarse.',
  open: 'Abrir',
  waitingparticipants: 'Esperando participantes',
  waitingresponses: 'Esperando respuestas',
  startNext: 'Comenzar siguiente',
  watchpodium: 'Mostrar podium',
  responses: '📶 Resultados',
  good: 'Correcto',
  bad: 'Incorrecto',
  na: 'NC',
  scoreboard: 'Clasificación',
  podium: 'Podium',
  solution: 'Solución',
  joinCompetition: 'Únete al mini torneo',

  noopencompetition: 'Ningún mini torneo abierto',
  youarein: '¡Listo para empezar!',
  waitingcompetitionstart: 'Esperando inicio del torneo',
  waitingnextchallenge: 'Esperando siguiente reto',
  preparetostart: '¡Prepárate para comenzar!',
  youranswer: 'Tu respuesta',
  goodchallengeanswer: '¡Respuesta correcta :-)!',
  badchallengeanswer: 'Respuesta incorrecta :-(',
  nochallengeanswer: 'Sin respuesta :-(',
  yourareinpodium: '¡Estás en el podium 🥇🥈🏅!',
  showSolution: 'Mostrar solución',
  showStats: 'Mostrar resultados',
  showClassifiaction: 'Mostrar clasificación',
  example: 'Ejemplo',

  filter: 'filtrar',
  all: 'todos',

};

export default es;
